import { type AssetsResponse, AssetsResponseSchema } from '../../domain/canvas/value-objects/asset'
import { assetRegistry } from '../services/assetRegistry'

export const fetchAssets = async (): Promise<AssetsResponse> => {
  const response = await fetch(`/api/assets`)

  if (!response.ok) {
    throw new Error(`Failed to fetch assets: ${response.status} ${response.statusText}`)
  }

  const data = await response.json()
  return AssetsResponseSchema.parse(data)
}

// Legacy function - kept for backward compatibility
export const getAssetUrl = (
  type: 'engrave' | 'print',
  folderName: string,
  filename: string,
): string => {
  // Encode the folder name and filename to handle spaces and special characters
  const encodedFolderName = encodeURIComponent(folderName)
  const encodedFilename = encodeURIComponent(filename)
  return `https://cdn.nicelittlethings.be/design-studio/assets/${type}/${encodedFolderName}/${encodedFilename}`
}

// New function using assetId
export const getAssetUrlById = async (assetId: string): Promise<string> => {
  const url = await assetRegistry.getAssetUrl(assetId)
  if (!url) {
    throw new Error(`Asset not found: ${assetId}`)
  }
  return url
}

// Helper to get asset info
export const getAssetInfoById = async (assetId: string) => {
  return assetRegistry.getAssetInfo(assetId)
}

/**
 * Converts a PNG asset URL to SVG for better canvas rendering quality
 * This ensures assets are displayed as vectors on the canvas, which prevents blurriness when scaled
 *
 * @param url - The asset URL (may be PNG or SVG)
 * @returns The URL with .svg extension
 */
export const ensureSvgAssetUrl = (url: string): string => {
  // Only convert PNG to SVG for CDN assets
  if (url.includes('cdn.nicelittlethings.be/design-studio/assets/') && url.endsWith('.png')) {
    return url.replace(/\.png$/i, '.svg')
  }
  return url
}
